/*!
 * Copyright © 2021. Verizon Connect Ireland Limited. All rights reserved.
 */

import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

export const APP_CONFIG = new InjectionToken<typeof environment.config>('appConfig');
